import { graphqlInstance } from "@platformx/authoring-apis";
import { PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import {
  CREATE_ROLE,
  DELETE_ROLE,
  GET_ROLE_LIST,
  IMPACTED_USER_COUNT,
  ROLE_PERMISSION_LIST,
  UPDATE_ROLE,
} from "./queries";

const graphQluserRole = {
  getRoleList: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: GET_ROLE_LIST,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getRoleList`, err);
      throw err;
    }
  },
  getRolePermissionList: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: ROLE_PERMISSION_LIST,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getRolePermissionList`, err);
      throw err;
    }
  },
  createRole: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: CREATE_ROLE,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:createRole`, err);
      throw err;
    }
  },
  deleteRole: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: DELETE_ROLE,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:createRole`, err);
      throw err;
    }
  },
  updateRole: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: UPDATE_ROLE,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:createRole`, err);
      throw err;
    }
  },
  getImpactedUserList: async <T>(input?: T): Promise<any> => {
    try {
      const { loading, errors, data } = await graphqlInstance.query({
        query: IMPACTED_USER_COUNT,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return { loading, errors, data };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getImpactedUserList`, err);
      throw err;
    }
  },
};
export default graphQluserRole;
